import { gql, useQuery } from "@apollo/client";

export interface Features {
  name: string;
  enabled: boolean;
  description?: string;
}

const query = gql`
  query getFeatures {
    features {
      name
      enabled
      description
    }
  }
`;

interface Data {
  features?: Features[];
}

interface UseFeatureReturns {
  loading: boolean;
  features?: Features[];
}

export default function useAllFeatures(): UseFeatureReturns {
  const { error, data, loading } = useQuery<Data>(query, {
    fetchPolicy: "cache-and-network",
    pollInterval: 600000, // we poll once every 10 minutes to ensure that we pick up any feature flag changes
  });

  if (error != null) throw error;
  return {
    loading,
    features: data?.features,
  };
}
